var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_404"},[_c('div',{staticClass:"info"},[_c('p',[_vm._v("哎呀，页面不存在...")]),_c('p',[_vm._v("休息一下,继续访问")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("回到首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }